import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import camelCase from 'camelcase';
import { properties } from '../common/css-properties.esm.js';
import { aliases, multiples, css } from '../css/index.esm.js';
import { useCallback } from 'react';

var config = {
  w: "width",
  minW: "minWidth",
  maxW: "maxWidth",
  h: "height",
  minH: "minHeight",
  maxH: "maxHeight",
  bgImg: "backgroundImage",
  bgSize: "backgroundSize",
  bgPos: "backgroundPosition",
  bgRepeat: "backgroundRepeat",
  pos: "position",
  flexDir: "flexDirection",
  dir: "flexDirection",
  direction: "flexDirection",
  align: "alignItems",
  justify: "justifyContent",
  wrap: "flexWrap",
  shadow: "boxShadow",
  templateColumns: "gridTemplateColumns",
  gap: "gridGap",
  rowGap: "gridRowGap",
  columnGap: "gridColumnGap",
  autoFlow: "gridAutoFlow",
  autoRows: "gridAutoRows",
  autoColumns: "gridAutoColumns",
  templateRows: "gridTemplateRows",
  templateAreas: "gridTemplateAreas",
  area: "gridArea",
  column: "gridColumn",
  row: "gridRow"
};
config["bgAttachment"] = config.backgroundAttachment;
config["textDecor"] = config.textDecoration;
config["listStylePos"] = config.listStylePosition;
config["listStyleImg"] = config.listStyleImage;
var variantProps = ["textStyle", "buttonStyle", "colorStyle"];
var hover = "&:hover";
var active = "&:active, &[data-active=true]";
var focus = "&:focus";
var visited = "&:visited";
var even = "&:nth-of-type(even)";
var odd = "&:nth-of-type(odd)";
var disabled = "&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover";
var checked = "&[aria-checked=true]";
var mixed = "&[aria-checked=mixed]";
var selected = "&[aria-selected=true]";
var invalid = "&[aria-invalid=true]";
var pressed = "&[aria-pressed=true]";
var readOnly = "&[aria-readonly=true], &[readonly]";
var first = "&:first-of-type";
var last = "&:last-of-type";
var expanded = "&[aria-expanded=true]";
var grabbed = "&[aria-grabbed=true]";
var notFirst = "&:not(:first-of-type)";
var notLast = "&:not(:last-of-type)";
var groupHover = "[role=group]:hover &";
var allPossibleProps = /*#__PURE__*/[].concat(variantProps, /*#__PURE__*/properties.map(function (prop) {
  return camelCase(prop);
}), /*#__PURE__*/Object.keys(aliases), /*#__PURE__*/Object.keys(multiples), /*#__PURE__*/Object.keys(config));
var useCss = function useCss(_ref) {
  var _pseudo2;

  var _after = _ref._after,
      _focus = _ref._focus,
      _selected = _ref._selected,
      _focusWithin = _ref._focusWithin,
      _hover = _ref._hover,
      _invalid = _ref._invalid,
      _active = _ref._active,
      _disabled = _ref._disabled,
      _grabbed = _ref._grabbed,
      _pressed = _ref._pressed,
      _expanded = _ref._expanded,
      _visited = _ref._visited,
      _before = _ref._before,
      _readOnly = _ref._readOnly,
      _first = _ref._first,
      _notFirst = _ref._notFirst,
      _notLast = _ref._notLast,
      _last = _ref._last,
      _placeholder = _ref._placeholder,
      _checked = _ref._checked,
      _groupHover = _ref._groupHover,
      _mixed = _ref._mixed,
      _odd = _ref._odd,
      _even = _ref._even,
      _cssProp = _ref.css,
      _sxProp = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, ["_after", "_focus", "_selected", "_focusWithin", "_hover", "_invalid", "_active", "_disabled", "_grabbed", "_pressed", "_expanded", "_visited", "_before", "_readOnly", "_first", "_notFirst", "_notLast", "_last", "_placeholder", "_checked", "_groupHover", "_mixed", "_odd", "_even", "css", "sx"]);

  var _css = {};

  var _pseudo = (_pseudo2 = {}, _pseudo2[hover] = _hover, _pseudo2[focus] = _focus, _pseudo2[active] = _active, _pseudo2[visited] = _visited, _pseudo2[disabled] = _disabled, _pseudo2[selected] = _selected, _pseudo2[invalid] = _invalid, _pseudo2[expanded] = _expanded, _pseudo2[grabbed] = _grabbed, _pseudo2[readOnly] = _readOnly, _pseudo2[first] = _first, _pseudo2[notFirst] = _notFirst, _pseudo2[notLast] = _notLast, _pseudo2[last] = _last, _pseudo2[odd] = _odd, _pseudo2[even] = _even, _pseudo2[mixed] = _mixed, _pseudo2[checked] = _checked, _pseudo2[pressed] = _pressed, _pseudo2[groupHover] = _groupHover, _pseudo2["&:before"] = _before, _pseudo2["&:after"] = _after, _pseudo2["&:focus-within"] = _focusWithin, _pseudo2["&::placeholder"] = _placeholder, _pseudo2);

  var rest = _extends({}, props);

  var isCssProp = useCallback(function (prop) {
    return allPossibleProps.find(function (cssProp) {
      return cssProp === prop;
    });
  }, []);
  var propKeys = Object.keys(props);
  propKeys.forEach(function (prop) {
    if (isCssProp(prop)) {
      _css[prop] = props[prop];
      delete rest[prop];
    }
  });

  var styles = function styles(theme) {
    var _styles = css(_css)(theme) || {};

    var pseudoStyles = css(_pseudo)(theme) || {};
    var cssPropStyles = css(_cssProp)(theme) || {};
    var sxPropStyles = css(_sxProp)(theme) || {};

    var result = _extends({}, _styles, pseudoStyles, cssPropStyles, sxPropStyles);

    return result;
  };

  return [styles, rest];
};

export { allPossibleProps, config, useCss };
//# sourceMappingURL=use-css.esm.js.map
